<page-loading *ngIf="!initialized"></page-loading>
<operator-sidebar-panel *ngIf="isOperatorMode"
                        [mpinfo]="marketPartnerInfo"
                        [upinfo]="companyPartnerInfo"
                        [activeViewMode]="'meteringpoints'"></operator-sidebar-panel>
<div id="page-content" [class.page-content-with-sidebar]="isOperatorMode">
  <metering-points-table *ngIf="initialized" [meteringPoints]="meteringPoints"></metering-points-table>
</div>
